import React, { useEffect, useState } from 'react';
import { invoicesApi } from '../services/api';

function fmt(n) {
  return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(n || 0);
}

export default function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');

  function load() {
    setLoading(true);
    invoicesApi.list({ limit: 100 }).then(r => setInvoices(r.data)).finally(() => setLoading(false));
  }
  useEffect(() => { load(); }, []);

  async function send(id) {
    await invoicesApi.send(id);
    setMsg('Faktura odeslána'); load();
  }

  return (
    <div>
      <div className="page-header"><h1 className="page-title">📄 Faktury</h1></div>
      {msg && <div className="alert alert-success">{msg}</div>}
      <div className="card">
        {loading ? <div className="loading-center"><div className="spinner" /></div> : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Číslo</th>
                  <th>Objednávka</th>
                  <th>Typ</th>
                  <th style={{ textAlign: 'right' }}>Celkem</th>
                  <th>Vystaveno</th>
                  <th>Odesláno</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {invoices.map(inv => (
                  <tr key={inv.id}>
                    <td style={{ fontWeight: 600 }}>{inv.invoice_number}</td>
                    <td style={{ fontSize: 12 }}>{inv.order_number || '—'}</td>
                    <td><span className={`badge ${inv.type === 'proforma' ? 'badge-waiting' : 'badge-paid'}`}>{inv.type}</span></td>
                    <td style={{ textAlign: 'right', fontWeight: 700 }}>{fmt(inv.total)}</td>
                    <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{inv.created_at?.slice(0, 10)}</td>
                    <td style={{ fontSize: 12 }}>{inv.sent_at ? <span style={{ color: 'var(--green)' }}>✓ {inv.sent_at.slice(0, 10)}</span> : <span style={{ color: 'var(--text-muted)' }}>Neodesláno</span>}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <a href={invoicesApi.pdfUrl(inv.id)} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm">PDF</a>
                        <button className="btn btn-primary btn-sm" onClick={() => send(inv.id)}>📧 Poslat</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {invoices.length === 0 && <div className="empty-state">Žádné faktury</div>}
          </div>
        )}
      </div>
    </div>
  );
}
